import CalendarToday from '@mui/icons-material/CalendarToday';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { FileSetDto } from 'api';
import { TextDisplay } from 'library/components/controls/display/TextDisplay';
import { DeleteRefreshFunction } from 'library/components/controls/files/UnitFileRemoveButton';
import { getLocalizedDateFormat } from 'library/formatters/DateFormatter';

import { FilesDisplay } from './FilesDisplay';

export const DateCommentFilesDisplay = ({
	date,
	dateLabel,
	comment,
	fileSet,
	onDelete,
}: {
	date: Date | null;
	dateLabel: string;
	comment: string | null;
	fileSet: FileSetDto | null | undefined;
} & DeleteRefreshFunction): React.JSX.Element => {
	const { t } = useTranslation(['commonWizard']);

	return (
		<>
			<Box
				sx={{
					display: 'grid',

					gridTemplateColumns: {
						xs: '1fr',
						sm: '1fr 2fr',
					},

					gap: { xs: 2, sm: 8 },
					mb: 4,
				}}>
				<TextDisplay
					label={dateLabel}
					value={getLocalizedDateFormat(date)}
					startIcon={<CalendarToday color="disabled" />}
				/>
				<TextDisplay
					label={t('commonWizard:additional-comment-label')}
					value={
						<Typography
							sx={{
								whiteSpace: 'pre-wrap',
							}}>
							{comment}
						</Typography>
					}
				/>
			</Box>
			<FilesDisplay fileSet={fileSet} onDelete={onDelete} />
		</>
	);
};
